import { styled } from '@mui/material'

export const TeamMembersTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'collapse',

  'th,td': {
    textAlign: 'left',
    font: '400 14px Poppins, sans-serif',
    padding: '12px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px !important',
    },

    div: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      img: {
        width: '45px',
        height: '45px',
        objectFit: 'cover',
      },
    },

    '&:first-of-type': {
      width: '50px',
    },
  },
  '.calendarStatus': {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    '&.connected': {
      color: theme.palette.success.main,
    },
    '&.notConnected': {
      color: theme.palette.error.main,
    },
  },
  thead: {
    background: '#F2F4F5',
    th: {
      color: theme.palette.primary.main,
      font: '600 16px Poppins, sans-serif',
      [theme.breakpoints.down('md')]: {
        fontSize: '12px !important',
      },
    },
    'th:first-of-type': {
      borderRadius: '12px 0 0 12px',
    },
    'th:last-of-type': {
      borderRadius: '0 12px 12px 0',
    },
  },
}))
